import Auth from "./Auth";
import { AuthState } from "../appinitandstate/AuthState";
import { auth0UserStub } from "./Auth0UserStub";
import {
  ACCESS_TOKEN_TO_USE_STORAGE_KEY,
  FAKE_TOKEN_PREFIX,
} from "./stub/StubTokenDefinition";
import { SONGSHIP_STUB_TOKEN } from "./stub/StubLogin";
import { RoutePaths } from "../RoutePaths";
import { NavigateFunction } from "react-router-dom";

export class AuthAlwaysAuthorizedStub extends Auth {
  constructor() {
    super();
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.getEmail = this.getEmail.bind(this);
    this.getIdToken = this.getIdToken.bind(this);
    this.renewSession = this.renewSession.bind(this);
    this.getTokenFromLocalStorage = this.getTokenFromLocalStorage.bind(this);
    this.getGrantedPermissionsString =
      this.getGrantedPermissionsString.bind(this);
    this.getAuth0Subject = this.getAuth0Subject.bind(this);
  }

  login(navigate: NavigateFunction) {
    //no op
    if (!location.href.includes(RoutePaths.STUB_LOGIN)) {
      navigate(`/${RoutePaths.STUB_LOGIN}`);
    }
  }

  handleAuthentication(): Promise<AuthState> {
    const locHash = window.location!.hash;
    const fake_token = locHash.replace(`#${SONGSHIP_STUB_TOKEN}=`, "");
    console.debug("Fake token will be persisted", fake_token);
    localStorage.setItem(ACCESS_TOKEN_TO_USE_STORAGE_KEY, fake_token);
    return Promise.resolve(AuthState.OkWithOnlineAuthentication);
  }

  private getTokenFromLocalStorage() {
    return localStorage.getItem(ACCESS_TOKEN_TO_USE_STORAGE_KEY);
  }

  getAccessToken(): string | undefined {
    const token = this.getTokenFromLocalStorage();
    if (token !== null && token.startsWith(FAKE_TOKEN_PREFIX)) {
      return token;
    } else {
      return undefined;
    }
  }

  getIdToken() {
    return "stubIdToken";
  }

  renewSession(resultCallback: (authenticationResult: AuthState) => void) {
    //no op
    resultCallback(AuthState.OkWithOnlineAuthentication);
  }

  logout() {
    localStorage.removeItem(ACCESS_TOKEN_TO_USE_STORAGE_KEY);
    window.location.href = window.location.origin;
  }

  isAuthenticated(): boolean {
    return this.getTokenFromLocalStorage() !== null;
  }

  getEmail(): string | undefined {
    const token = this.getAccessToken();
    if (token) {
      return token + "@example.com";
    }
    return undefined;
  }

  protected getGrantedPermissionsString(): string | undefined {
    const token = this.getAccessToken();
    if (!token) return undefined;
    const fakeEntry = auth0UserStub.find((v) => token === v.token());
    if (fakeEntry === undefined)
      throw new Error(`No entry found in stub file for ${token}`);

    return fakeEntry.content.permissions.join(",");
  }

  getAuth0Subject(): string {
    const token = this.getAccessToken();
    if (!token) throw new Error("Illegal State: expected not to be undefined.");
    return `songshipStubSecurity|${token}`;
  }

  getRefreshTokenAfter(): number | undefined {
    return undefined;
  }
}
